import { createContext, ReactNode, useContext } from "react"
import { BetterDocRejectionReasonDialog } from "@/modules/patients/detail/better-doc/components/better-doc-rejection-reason-dialog"
import { BetterDocUsageFailureDialog } from "@/modules/patients/detail/better-doc/components/better-doc-usage-failure-dialog"
import type { PointOfCareBetterDoc } from "@/modules/patients/detail/better-doc/hooks/usePointOfCareBetterDoc"

const PointOfCareBetterDocContext = createContext<PointOfCareBetterDoc | null>(null)

type PointOfCareBetterDocProviderProps = { children: ReactNode; pointOfCareBetterDoc: PointOfCareBetterDoc }

export const PointOfCareBetterDocProvider = ({ children, pointOfCareBetterDoc }: PointOfCareBetterDocProviderProps) => {
  return (
    <PointOfCareBetterDocContext.Provider value={pointOfCareBetterDoc}>
      {children}
      <BetterDocRejectionReasonDialog
        open={pointOfCareBetterDoc.isRejectionDialogOpen}
        isConfirming={pointOfCareBetterDoc.isConfirmingBetterDocRejection}
        onCancel={pointOfCareBetterDoc.handleRejectionCancel}
        onConfirm={pointOfCareBetterDoc.handleRejectionConfirm}
        onCloseAutoFocus={pointOfCareBetterDoc.handleRejectionDialogCloseAutoFocus}
      />
      <BetterDocUsageFailureDialog
        open={pointOfCareBetterDoc.shouldShowBetterDocUsageFailure}
        onClose={pointOfCareBetterDoc.dismissBetterDocUsageFailure}
      />
    </PointOfCareBetterDocContext.Provider>
  )
}

export const usePointOfCareBetterDocContext = (): PointOfCareBetterDoc => {
  const pointOfCareBetterDoc = useContext(PointOfCareBetterDocContext)
  if (!pointOfCareBetterDoc) throw new Error("Missing PointOfCareBetterDocProvider in the tree")
  return pointOfCareBetterDoc
}
